import React from 'react';
import { Tag, Input, Tooltip, Icon, } from 'antd';

import { executeGetTags } from '../../simbix/executer'

class TagGroup extends React.Component {
  
    constructor(props, context) {
        super(props, context)
        this.state = {
            loading: false, 			//Флаг загрузки
            tags: [],
            inputVisible: false,
            inputValue: '',
        }
    }
    
    componentWillMount() { 
        this.loadTags();
    }

    loadTags() {
        this.setState({loading: true})
        return executeGetTags()
        .then ((response) =>{
            const {data} = response
//            this.setState({loading: false, tags: data.tags.map(tag => tag.name)});
            this.setState({loading: false, tags: data.tags});
            return Promise.resolve(response)
        })
        .catch(e => { 
            return Promise.reject(e);
        });
    }

    handleClose = (removedTag) => {
      const tags = this.state.tags.filter(tag => tag !== removedTag);
      console.log(tags);
      this.setState({ tags });
    }
  
    showInput = () => {
      this.setState({ inputVisible: true }, () => this.input.focus());
    }
  
    handleInputChange = (e) => {
      this.setState({ inputValue: e.target.value });
    }
  
    handleInputConfirm = () => {
      const state = this.state;
      const inputValue = state.inputValue;
      let tags = state.tags;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      this.setState({
        tags,
        inputVisible: false,
        inputValue: '',
      });
    }
  
    saveInputRef = input => this.input = input
  
    render() {
      const { tags, inputVisible, inputValue } = this.state;
      return (
        <div style={{ width: 320 }}>
          {tags.map((tag, index) => {
            const isLongTag = tag.name.length > 20;
            const tagElem = (
              <Tag key={tag.name} closable={false} afterClose={() => this.handleClose(tag)}>
                {isLongTag ? `${tag.name.slice(0, 20)}...` : tag.name} ({tag.count})
              </Tag>
            );
            return isLongTag ? <Tooltip title={tag} key={tag}>{tagElem}</Tooltip> : tagElem;
          })}
        </div>
      );
    }
  }
  
  export default TagGroup